/**
 * @typedef {import('./lib/index.js').Action} Action
 * @typedef {import('./lib/index.js').ActionTuple} ActionTuple
 * @typedef {import('./lib/index.js').Index} Index
 * @typedef {import('./lib/index.js').Visitor} Visitor
 * @typedef {import('./lib/index.js').Visitors} Visitors
 */

export {CONTINUE, EXIT, SKIP, visit} from './lib/index.js'
